package de.ohhhmhhh.backend.models.model.checkout

import kotlinx.serialization.Serializable

@Serializable
data class CreateSubscriptionCheckoutSessionRequest(
    val userId: String,
    val paymentMethod: PaymentMethodEntity,
    val price: Int?,
)